import { createSelector } from 'reselect'

export const getFormLoading = createSelector(
  state => Boolean(state && state.common && state.common.form && state.common.form.isLoading),
  isLoading => isLoading
)
